import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { withTranslation } from 'react-i18next'

import GitlabIntegrationCreationModal from './GitlabIntegrationCreationModal'
import GitlabIntegrationModal from './GitlabIntegrationModal'
import IntegrationCreationCard from './IntegrationCreationCard'
import IntegrationDeleteConfirmModal from './IntegrationDeleteConfirmModal'
import integrationsActions from '../../integrations/actions'
import { HeaderFooterCard } from './IntegrationCardDesigns'

class Integrations extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      openModal: false,
      openCreationModal: false,
      openDeleteModal: false,
      integrationToDelete: null
    }
  }

  hideEditIntegrationModal() {
    this.setState({
      openModal: false
    })
  }

  showEditIntegrationModal() {
    this.setState({
      openModal: true
    })
  }

  hideDeleteModal() {
    this.setState({
      openDeleteModal: false,
      integrationToDelete: null
    })
  }

  showDeleteModal(integration) {
    this.setState({
      openDeleteModal: true,
      integrationToDelete: integration
    })
  }

  hideCreationModal() {
    this.setState({
      openCreationModal: false
    })
  }

  showCreationModal() {
    this.setState({
      openCreationModal: true
    })
  }

  render() {
    const {
      dispatch,
      fetchingStatus,
      integrations,
      role,
      t
    } = this.props

    const {
      openModal,
      openCreationModal,
      openDeleteModal,
      integrationToDelete
    } = this.state

    if (fetchingStatus === 'idle'
        || (fetchingStatus === 'failed' && integrations === null)) {
      dispatch(integrationsActions.fetchAll())
    }

    const gitlabIntegration = integrations && integrations.find(
      (integration) => integration.platform === 'gitlab'
    )

    return (
      <section
        className="d-flex flex-column"
        name="integrations"
      >
        <header>
          <h3 className="ms-2">
            {t('Integrations.sections.integrations')}
          </h3>
        </header>

        <div className="d-flex flex-wrap gap-3">
          {gitlabIntegration && (
            <HeaderFooterCard
              integration={gitlabIntegration}
              onClickDelete={() => this.showDeleteModal(gitlabIntegration)}
              onClickEdit={() => this.showEditIntegrationModal()}
              role={role}
            />
          )}

          {role === 'admin' && (
            <IntegrationCreationCard
              onClick={() => this.showCreationModal()}
              title={t('Integrations.buttons.addIntegration')}
            />
          )}
        </div>

        {gitlabIntegration && (
          <GitlabIntegrationModal
            integration={gitlabIntegration}
            isOpen={openModal}
            onClose={() => this.hideEditIntegrationModal()}
          />
        )}

        <IntegrationDeleteConfirmModal
          integration={integrationToDelete}
          isOpen={openDeleteModal}
          onClose={() => this.hideDeleteModal()}
        />

        <GitlabIntegrationCreationModal
          isOpen={openCreationModal}
          onClose={() => this.hideCreationModal()}
        />
      </section>
    )
  }
}

Integrations.propTypes = {
  dispatch: PropTypes.func.isRequired,
  fetchingStatus: PropTypes.string,
  integrations: PropTypes.arrayOf(PropTypes.shape({
    platform: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired
  })),
  role: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired
}

Integrations.defaultProps = {
  fetchingStatus: 'idle',
  integrations: null
}

const mapStateToProps = ({
  authentication: {
    role
  },
  integrations: {
    fetchingStatus,
    items: integrations
  }
}) => ({
  fetchingStatus,
  integrations,
  role
})

export default withTranslation('SettingsPage')(
  connect(mapStateToProps)(Integrations)
)
